import styled from "styled-components";

export const PTModalContainer = styled.div`
  min-width: 600px;
  min-height: 48vh;
  max-height: 85vh;
  overflow-y: scroll;
  padding: 25px;
`;
